import dayjs from "@/lib/day";
import LogicaAPI from "./logicaapi";

class Terms extends LogicaAPI {
  async getTerm(key, withAgreement) {
    const params = {
      with_current_revision: true,
      ts: dayjs().unix(),
    };
    if (withAgreement && this.context?.req?.userToken) {
      params["with_agreement"] = true;
    }
    return await this.get(`/api/v1/terms/${key}`, {params});
  }

  agree(key) {
    const params = {
      revision_unique_key: key,
    };
    return this.post("/api/v1/terms/agree", { body: params });
  }
}
export default Terms;
